import { render, staticRenderFns } from "./CollectFileDialog.vue?vue&type=template&id=070fc5a4&scoped=true&"
import script from "./CollectFileDialog.vue?vue&type=script&lang=ts&"
export * from "./CollectFileDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CollectFileDialog.vue?vue&type=style&index=0&id=070fc5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fc5a4",
  null
  
)

export default component.exports